import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c4c047ec&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.8.1_webpack@5.88.0__lodash@4.17.21_vue-template-compiler@2.6.14_webpack@5.88.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports